import {config, http} from './__http';

export default {

    getCurrencyOptions(currencies) {
        http.get(config.baseUrl() + '/currency').then(response => {
            currencies(response.data)
        }).catch(e => {
            console.error(e);
        });
    },
    getCurrencySymbol(currencySymbol, currencyCode) {
        http.get(config.baseUrl() + '/currency/' + currencyCode + '/symbol').then(response => {
            currencySymbol(response.data)
        }).catch(e => {
            console.error(e);
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/Currency.js